import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as l, normalizeClass as o, createElementVNode as d } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCloudSnow",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], u = /* @__PURE__ */ d("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.598 2.209a3 3 0 0 0-3.24 4.89.5.5 0 0 1-.715.7A4 4 0 1 1 8.209 3.5h.54c.001 0 0 0 0 0a2.75 2.75 0 0 1 1.529 5.037.5.5 0 1 1-.556-.832A1.75 1.75 0 0 0 8.75 4.5h-.895a.5.5 0 0 1-.48-.357A3 3 0 0 0 5.599 2.21Z",
  "clip-rule": "evenodd"
}, null, -1), _ = /* @__PURE__ */ d("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.5 7.5A.5.5 0 0 1 4 7h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm0 2A.5.5 0 0 1 4 9h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm2-1A.5.5 0 0 1 6 8h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm0 2A.5.5 0 0 1 6 10h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm2-3A.5.5 0 0 1 8 7h.005a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Zm0 2A.5.5 0 0 1 8 9h.005a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  u,
  _
];
function m(e, f, r, p, A, a) {
  return l(), i("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--cloud-snow"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Cloud Snow",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, h, 10, c);
}
const H = /* @__PURE__ */ n(s, [["render", m]]);
export {
  H as default
};
//# sourceMappingURL=cloud-snow.js.map
